import React, { useState, useRef, useEffect } from "react";
import Navbar from "../../components/Navbar";
import Footer from "../../components/Footer";
import "../../assets/styles/footerfiles.css";
import { useNavigate } from "react-router-dom";
import SearchableDropDown from "../../components/widgets/SearchableDropDown";
import generateJobDescription from "../../utils/AiTools/generateJobDescription";

const INDUSTRIES = [
  "Tecnología",
  "Finanzas",
  "Salud",
  "Educación",
  "Marketing",
  "Diseño",
  "Ventas",
  "Recursos Humanos",
  "Manufactura",
  "Servicios",
  "Agroindustria",
  "Construcción",
  "Telecomunicaciones",
  "Logística y Transporte",
  "Energía y Minería",
  "Comercio",
  "Turismo y Hospitalidad",
  "Bienes Raíces",
  "Medios y Entretenimiento",
  "Consultoría",
  "Otro",
];

const TONES = ["Formal", "Normal", "Amigable"];

const COMMON_JOBS = [
  "Asesor Comercial",
  "Asistente Administrativo",
  "Desarrollador Web",
  "Analista de Datos",
  "Community Manager",
  "Recursos Humanos",
  "Marketing Digital",
  "Ejecutivo de Ventas",
  "Asesor de Servicio al Cliente",
];

const LoadingMessages = () => {
  const messages = [
    "Entendiendo el puesto...",
    "Recogiendo requisitos...",
    "Analizando la industria...",
    "Creando la vacante...",
    "Añadiendo detalles...",
    "Finalizando...",
  ];

  const [currentMessage, setCurrentMessage] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentMessage((prev) => (prev + 1) % messages.length);
    }, 2000);

    return () => clearInterval(interval);
  }, [messages.length]);

  return (
    <div className="text-center mt-8 mb-4">
      <p className="text-purple-600 font-medium text-lg tracking-wide">
        {messages[currentMessage]}
      </p>
    </div>
  );
};

const LoadingSkeleton = () => {
  return (
    <div className="space-y-4">
      <div className="flex flex-col items-center justify-center mb-6">
        <div className="relative">
          <div className="relative w-16 h-16">
            {/* Magic wand handle */}
            <div className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 w-2 h-8 bg-gradient-to-b from-purple-400 to-purple-600 rounded-full transform -rotate-45"></div>

            {/* Magic wand star */}
            <div className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 w-6 h-6">
              <div className="absolute inset-0 bg-gradient-to-r from-purple-400 to-purple-600 rounded-full transform rotate-45"></div>
              <div className="absolute inset-0 bg-gradient-to-r from-purple-400 to-purple-600 rounded-full transform -rotate-45"></div>
            </div>

            {/* Sparkle effects */}
            <div className="absolute -top-2 -right-2 w-2 h-2 bg-purple-400 rounded-full animate-ping"></div>
            <div
              className="absolute -bottom-2 -left-2 w-2 h-2 bg-purple-400 rounded-full animate-ping"
              style={{ animationDelay: "0.5s" }}
            ></div>
            <div
              className="absolute -top-2 -left-2 w-2 h-2 bg-purple-400 rounded-full animate-ping"
              style={{ animationDelay: "1s" }}
            ></div>
            <div
              className="absolute -bottom-2 -right-2 w-2 h-2 bg-purple-400 rounded-full animate-ping"
              style={{ animationDelay: "1.5s" }}
            ></div>
          </div>

          {/* Glow effect */}
          <div className="absolute inset-0 bg-purple-400 rounded-full opacity-20 blur-xl animate-pulse"></div>
        </div>
        <LoadingMessages />
      </div>
      <div className="space-y-4 animate-pulse">
        <div className="h-4 bg-gray-200 rounded w-1/4"></div>
        <div className="h-4 bg-gray-200 rounded w-1/3"></div>
        <div className="space-y-2">
          <div className="h-4 bg-gray-200 rounded"></div>
          <div className="h-4 bg-gray-200 rounded"></div>
          <div className="h-4 bg-gray-200 rounded w-5/6"></div>
        </div>
        <div className="space-y-2">
          <div className="h-4 bg-gray-200 rounded"></div>
          <div className="h-4 bg-gray-200 rounded"></div>
          <div className="h-4 bg-gray-200 rounded w-4/6"></div>
        </div>
        <div className="space-y-2">
          <div className="h-4 bg-gray-200 rounded"></div>
          <div className="h-4 bg-gray-200 rounded"></div>
          <div className="h-4 bg-gray-200 rounded w-3/6"></div>
        </div>
      </div>
    </div>
  );
};

function CreaTuVacante() {
  const navigate = useNavigate();
  const detailsSectionRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    document.title = "Crea tu Vacante - Laburo";
  }, []);

  const [jobDetails, setJobDetails] = useState({
    title: "",
    company: "",
    location: "",
    type: "",
    description: "",
    requirements: "",
    benefits: "",
  });

  const [aiInput, setAiInput] = useState({
    jobTitle: "",
    industry: "",
    tone: "",
    company: "",
    location: "",
  });
  const [isGenerating, setIsGenerating] = useState(false);
  const [showCopyToast, setShowCopyToast] = useState(false);
  const [showErrorToast, setShowErrorToast] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");

  const handleAiInputChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>
  ) => {
    const { name, value } = e.target;
    setAiInput((prev) => ({ ...prev, [name]: value }));
  };

  const handleIndustryChange = (value: string) => {
    setAiInput((prev) => ({ ...prev, industry: value }));
  };

  const handleToneChange = (
    value: string | ((prevState: string) => string)
  ) => {
    const newValue = typeof value === "function" ? value(aiInput.tone) : value;
    setAiInput((prev) => ({ ...prev, tone: newValue }));
  };

  const handleCopy = () => {
    const formattedText = `
🏢 ${jobDetails.company}
📍 ${jobDetails.location}


${jobDetails.title}

📝 Descripción:
${jobDetails.description}

✅ Requisitos:
${jobDetails.requirements}

✨ Beneficios:
${jobDetails.benefits}

#Empleo #Trabajo #OportunidadLaboral
    `.trim();

    navigator.clipboard.writeText(formattedText);
    setShowCopyToast(true);
    setTimeout(() => setShowCopyToast(false), 2000);
  };

  const handlePositionClick = (job: string) => {
    setAiInput((prev) => ({ ...prev, jobTitle: job }));
    if (detailsSectionRef.current) {
      const offset = 25;
      const elementPosition =
        detailsSectionRef.current.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - offset;

      window.scrollTo({
        top: offsetPosition,
        behavior: "smooth",
      });
    }
  };

  const generateJobDescriptionCall = async () => {
    if (
      !aiInput.jobTitle.trim() ||
      !aiInput.industry ||
      !aiInput.tone ||
      !aiInput.company.trim() ||
      !aiInput.location.trim()
    ) {
      setErrorMessage("Por favor, completa todos los campos");
      setShowErrorToast(true);
      setTimeout(() => setShowErrorToast(false), 2000);
      return;
    }

    setIsGenerating(true);
    try {
      // input industry, tone, jobTitle
      // return  title, description, requirements, benefits
      const response = await generateJobDescription(
        aiInput.industry,
        aiInput.tone,
        aiInput.jobTitle,
        aiInput.company,
        aiInput.location
      );

      if (!response.success) {
        setErrorMessage(response.message);
        setShowErrorToast(true);
        setTimeout(() => setShowErrorToast(false), 2000);
        return;
      }

      setJobDetails((prev) => ({
        ...prev,
        title: response.result.title,
        company: aiInput.company,
        location: aiInput.location,
        description: response.result.description,
        requirements: response.result.requirements,
        benefits: response.result.benefits,
      }));
    } catch (error) {
      console.error("Error generating job description:", error);
      setErrorMessage(
        "Hubo un error al generar la descripción. Por favor, intenta de nuevo."
      );
      setShowErrorToast(true);
      setTimeout(() => setShowErrorToast(false), 2000);
    } finally {
      setIsGenerating(false);
    }
  };

  return (
    <div className="w-full min-h-screen bg-white">
      <Navbar
        scrollPast={true}
        hidePanel={true}
        hideSignIn={true}
        lockNavbar={true}
        hideSearch={true}
      />

      <div className="max-w-[1000px] mx-auto px-4 md:px-8 py-16">
        {/* Header */}
        <div className="text-center mb-8">
          <h1 className="text-4xl font-bold text-gray-900 mb-4">
            Crea tu Vacante con IA
          </h1>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto mb-8">
            Genera descripciones de puestos profesionales en segundos
          </p>
        </div>

        {/* Job Title Suggestions */}
        <div className="mb-12 bg-gray-50 rounded-2xl p-4 sm:p-8 border border-gray-100">
          <h3 className="text-lg font-medium text-gray-700 mb-4 sm:mb-6 text-center">
            Puestos más buscados
          </h3>
          <div className="flex flex-wrap justify-center gap-2 sm:gap-3">
            {COMMON_JOBS.map((job) => (
              <button
                key={job}
                onClick={() => handlePositionClick(job)}
                className="px-3 sm:px-5 py-2 text-xs sm:text-sm font-medium rounded-full transition-all duration-300 hover:shadow-lg active:scale-95 bg-gradient-to-r from-blue-500 to-purple-600 text-white hover:from-blue-600 hover:to-purple-700 transform hover:-translate-y-1"
              >
                {job}
              </button>
            ))}
          </div>
        </div>

        {/* Copy Toast Notification */}
        {showCopyToast && (
          <div className="fixed top-8 left-1/2 transform -translate-x-1/2 bg-gray-900 text-white px-6 py-3 rounded-lg shadow-lg transform transition-all duration-300 animate-fade-in z-50">
            <div className="flex items-center gap-2">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-5 w-5"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2"
                />
              </svg>
              <span>¡Texto copiado al portapapeles!</span>
            </div>
          </div>
        )}

        {/* Error Toast Notification */}
        {showErrorToast && (
          <div className="fixed top-8 left-1/2 transform -translate-x-1/2 bg-red-600 text-white px-6 py-3 rounded-lg shadow-lg transform transition-all duration-300 animate-fade-in z-50">
            <div className="flex items-center gap-2">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-5 w-5"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                />
              </svg>
              <span>{errorMessage}</span>
            </div>
          </div>
        )}

        <div className="grid grid-cols-1 gap-8">
          {/* AI Input Section */}
          <div className="space-y-6" ref={detailsSectionRef}>
            <div className="bg-white p-6 rounded-xl shadow-[0_4px_24px_-4px_rgba(0,0,0,0.03)] border border-gray-100">
              <h2 className="text-2xl font-semibold text-gray-900 mb-6">
                Detalles del Puesto
              </h2>

              <div className="space-y-6">
                <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">
                      Título del Puesto
                    </label>
                    <input
                      type="text"
                      name="jobTitle"
                      value={aiInput.jobTitle}
                      onChange={handleAiInputChange}
                      className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent bg-white autofill:bg-white"
                      placeholder="Ej: Asesor de Ventas"
                    />
                  </div>

                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">
                      Industria
                    </label>
                    <SearchableDropDown
                      options={INDUSTRIES}
                      placeholder="Selecciona una industria"
                      value={aiInput.industry}
                      onChange={handleIndustryChange}
                    />
                  </div>

                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">
                      Tono del Anuncio
                    </label>
                    <SearchableDropDown
                      options={TONES}
                      placeholder="Selecciona un tono"
                      value={aiInput.tone}
                      onChange={handleToneChange}
                      noSearch={true}
                    />
                  </div>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">
                      Nombre de la Empresa
                    </label>
                    <input
                      type="text"
                      name="company"
                      value={aiInput.company}
                      onChange={handleAiInputChange}
                      className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent bg-white autofill:bg-white"
                      placeholder="Ej: Tech Solutions S.A."
                    />
                  </div>

                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">
                      Ubicación
                    </label>
                    <input
                      type="text"
                      name="location"
                      value={aiInput.location}
                      onChange={handleAiInputChange}
                      className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent bg-white autofill:bg-white"
                      placeholder="Ej: Quito"
                    />
                  </div>
                </div>

                <button
                  onClick={generateJobDescriptionCall}
                  disabled={isGenerating}
                  className="w-full bg-gray-900 hover:bg-gray-800 text-white transition-all duration-300 text-[14px] py-3 px-6 rounded-xl hover:translate-y-[-1px] active:translate-y-[1px] font-medium tracking-wide disabled:opacity-50 disabled:cursor-not-allowed"
                >
                  {isGenerating ? "Generando..." : "Generar Descripción con IA"}
                </button>
              </div>
            </div>
          </div>

          {/* Preview Section */}
          <div className="bg-white p-6 rounded-xl shadow-[0_4px_24px_-4px_rgba(0,0,0,0.03)] border border-gray-100">
            <div className="flex justify-between items-center mb-6">
              <h2 className="text-2xl font-semibold text-gray-900">
                Vista Previa
              </h2>
              {!isGenerating && jobDetails.title && (
                <button
                  onClick={handleCopy}
                  className="flex items-center gap-2 bg-gradient-to-r from-purple-500 to-purple-600 hover:from-purple-600 hover:to-purple-700 text-white transition-all duration-300 text-[14px] py-2 px-4 rounded-lg hover:translate-y-[-1px] active:translate-y-[1px] font-medium tracking-wide shadow-lg hover:shadow-purple-200"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="h-4 w-4"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M8 5H6a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2v-1M8 5a2 2 0 002 2h2a2 2 0 002-2M8 5a2 2 0 012-2h2a2 2 0 012 2m0 0h2a2 2 0 012 2v3m2 4H10m0 0l3-3m-3 3l3 3"
                    />
                  </svg>
                  Copiar
                </button>
              )}
            </div>

            <div className="bg-gray-50 p-6 rounded-lg whitespace-pre-wrap font-mono text-sm min-h-[300px] flex items-center justify-center">
              {isGenerating ? (
                <LoadingSkeleton />
              ) : jobDetails.title ? (
                <>
                  {jobDetails.company && `🏢 ${jobDetails.company}\n`}
                  {jobDetails.location && `📍 ${jobDetails.location}\n\n`}

                  {jobDetails.title && `${jobDetails.title}\n\n`}
                  {jobDetails.description &&
                    `📝 Descripción:\n${jobDetails.description}\n\n`}
                  {jobDetails.requirements &&
                    `✅ Requisitos:\n${jobDetails.requirements}\n\n`}
                  {jobDetails.benefits &&
                    `✨ Beneficios:\n${jobDetails.benefits}`}
                </>
              ) : (
                <div className="flex flex-col items-center justify-center text-gray-400">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="h-12 w-12 mb-4"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={1.5}
                      d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
                    />
                  </svg>
                  <p className="text-center text-lg font-medium">
                    Completa los detalles del puesto
                  </p>
                  <p className="text-center text-sm mt-2">
                    La vista previa aparecerá aquí una vez que generes la
                    descripción
                  </p>
                </div>
              )}
            </div>
          </div>
        </div>

        {/* Promotional Section */}
        <div className="mt-16 bg-gray-900 rounded-xl p-8 text-white">
          <div className="max-w-3xl mx-auto text-center">
            <h2 className="text-2xl font-bold mb-4">
              ¿Quieres revolucionar tu proceso de reclutamiento?
            </h2>
            <p className="text-gray-300 mb-6">
              Laburo es tu ATS inteligente que simplifica el reclutamiento,
              optimiza tu tiempo y te hace brillar. <br></br>¡Transforma tus
              procesos de contratación hoy!
            </p>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-8">
              <div className="bg-gray-800 p-4 rounded-lg">
                <div className="text-2xl mb-2">⚡</div>
                <h3 className="font-semibold mb-2">Automatización e IA</h3>
                <p className="text-sm text-gray-300">
                  Automatiza tareas y aprovecha la IA para ser más eficiente
                </p>
              </div>
              <div className="bg-gray-800 p-4 rounded-lg">
                <div className="text-2xl mb-2">🌐</div>
                <h3 className="font-semibold mb-2">Trabaja con Nosotros</h3>
                <p className="text-sm text-gray-300">
                  Crea tu propia página de empleos y muestra tu cultura
                  empresarial
                </p>
              </div>
              <div className="bg-gray-800 p-4 rounded-lg">
                <div className="text-2xl mb-2">📋</div>
                <h3 className="font-semibold mb-2">Base de Datos</h3>
                <p className="text-sm text-gray-300">
                  Gestiona todos tus candidatos en una base de datos
                  centralizada
                </p>
              </div>
            </div>
            <button
              onClick={() => navigate("/empresas")}
              className="inline-flex items-center gap-2 bg-white hover:bg-gray-100 text-gray-900 transition-all duration-300 text-[14px] py-3 px-6 rounded-xl hover:translate-y-[-1px] active:translate-y-[1px] font-medium tracking-wide"
            >
              <span>Conoce más sobre Laburo</span>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-4 w-4"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M9 5l7 7-7 7"
                />
              </svg>
            </button>
          </div>
        </div>
      </div>

      <Footer type={2} />
    </div>
  );
}

export default CreaTuVacante;
